import { CONTAINER_PREFIX } from '@/constants/PREFIX.ts'

export const RELEVANT_STORIES_CONTAINER = `${CONTAINER_PREFIX}RELEVANT_STORIES_CONTAINER`
export const IPM_CONTAINER = `${CONTAINER_PREFIX}IPM_CONTAINER`
export const PRE_IPM_CONTAINER = `${CONTAINER_PREFIX}PRE_IPM_CONTAINER`
export const DRAFT_CONTAINER = `${CONTAINER_PREFIX}DRAFT_CONTAINER`
